const MAX_NAME = 10;
const MAX_TITLE = 40;
const MAX_CONTENT = 60;
const MAX_IMG_SIZE = 10000000;
const THEME1_HEIGHT = 377;
const THEME1_WIDTH = 560;
const SP_THEME1_HEIGHT = 232;
const SP_THEME1_WIDTH = 355;
const THEME3_HEIGHT = 420;
const THEME3_WIDTH = 514;
const SP_THEME3_HEIGHT = 253;
const SP_THEME3_WIDTH = 310;
export {
    MAX_NAME,
    MAX_TITLE,
    MAX_CONTENT,
    MAX_IMG_SIZE,
    THEME1_HEIGHT,
    THEME1_WIDTH,
    SP_THEME1_HEIGHT,
    SP_THEME1_WIDTH,
    THEME3_HEIGHT,
    THEME3_WIDTH,
    SP_THEME3_HEIGHT,
    SP_THEME3_WIDTH
}